/**
 * Validates `returnUrl` query values for post-login redirect (open-redirect safe).
 * Only allows relative paths under `/vi` or `/en`.
 */
export function sanitizeReturnUrl(raw: string | null | undefined): string | null {
  if (raw == null || raw === "") {
    return null
  }
  let decoded = raw
  try {
    decoded = decodeURIComponent(raw.trim())
  } catch {
    return null
  }
  if (decoded.includes("://") || decoded.startsWith("//")) {
    return null
  }
  if (!decoded.startsWith("/")) {
    return null
  }
  if (/^javascript:/i.test(decoded.replace(/\s/g, ""))) {
    return null
  }
  if (!/^\/(vi|en)(\/|\?|$)/.test(decoded)) {
    return null
  }
  return decoded
}
